import { getObject } from "@/utils/hooks/localStorage";
import axios from "axios";
const baseURL: any = process.env.REACT_APP_API_URL;

export function sendUserPaymentMethod(body: any) {
  const uuid = getObject("uuid");
  const url = `${baseURL}/comandos/registrar/metodo-pago/${uuid}`;
  return axios.put(url, body);
}

export const validateTransUnion = (cedula: string) => {
  return axios.post(`${baseURL}/auth/trans`, { cedula });
};
